import React from 'react'
import { useModalStateStore } from '../../utils'
import styles from './LotTableActions.module.css'

export const LotTableActions = ({
    canLink,
    onEditModalClick
}: {
    canLink: boolean | undefined
    onEditModalClick: () => void
}) => {
    const { openModal } = useModalStateStore()

    return (
        <div
            onClick={() => {
                openModal('LotEditModal')
                onEditModalClick()
            }}
            className={styles.root}
        >
            {!canLink && <i className="material-icons">edit</i>}
            {canLink && <i className="material-icons">add_link</i>}
        </div>
    )
}
